import { createActions } from 'redux-actions';

import { CompanyUser } from '@models/User';

export type State = {
  companyUsers: CompanyUser[];
};

export type StateUpdatePayload = Partial<State>;

export const {
  companyUsersFetch,
  stateUpdate,
} = createActions(
  'COMPANY_USERS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_USER',
  },
);
